import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { removeInstitutes, userInstituteMappingQueryKeys } from '../api/userInstituteMapping.api';
import type { RemoveInstitutesPayload } from '../types/userInstituteMapping.types';

export function useRemoveInstitutes(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: RemoveInstitutesPayload) => removeInstitutes(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: userInstituteMappingQueryKeys.all(),
      });
      toast.success('Institute removed successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to remove institute');
    },
  });
}
